import Backbone from "backbone-lite";

import {khanFetch} from "@khan/data-fetch";

// Provide an Ajax implementation to Backbone-lite using khanFetch
Backbone.ajax = function (options) {
    const args = {
        method: options.type,
    };

    if (options.contentType) {
        args.headers = {
            "Content-Type": options.contentType,
        };
    }

    if (options.data) {
        args.body = options.data;
    }

    const request = khanFetch(options.url, args);

    if (options.success) {
        // It's assumed that all responses are JSON, which is probably
        // a safe assumption, in our case.
        request
            .then((res) => {
                if (options.type === "DELETE") {
                    return (
                        res
                            .text()
                            // Allow DELETE actions with an empty response body
                            .then((text) => (text ? JSON.parse(text) : null))
                    );
                }
                return res.json();
            })
            .then(options.success);
    }

    if (options.error) {
        request.catch(options.error);
    }

    return request;
};

export default Backbone;
